import basicController from 'servicestack/basic.controller.properties'
import templateUrl from 'emun.offer/offer-edit.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import resolve from 'ioc/resolve'
import Product from 'emun.shopping/product.model'

class OfferEditController {
    constructor() {
        const $ctrl = this;
        basicController($ctrl);
    }
    $onInit(){
        const $ctrl = this;
        const id = $ctrl.offerId;
        $ctrl.selectAll = false;
        $ctrl.displayTypes = [{ id: 'Add to Cart' }, { id: 'Checkout' }];
        if (id == 'create') {
            $ctrl.offer = { id: 'create' };
        } else {
            let options = {
                url: 'QueryOffers.json?Id=' + id,
                autoLoad: true,
                pageSize: 24,
                append: false,
                onLoaded: args => {
                    $ctrl.offer = args.first
                    $ctrl.offer.startOn = moment($ctrl.offer.startOn);
                    $ctrl.offer.endOn = moment($ctrl.offer.endOn);
                }
            };
            $ctrl.query = new AutoQuery(options);
            $ctrl.qualifyProducts = new AutoQuery({
                url: 'QueryOfferProductsQualify/' + id,
                autoLoad: true, append: false, take: 24,
                scrub(response) {
                    response.data.results = Product.map(response.data.results);
                } });

            $ctrl.rewardProducts = new AutoQuery({
                url: 'QueryOfferProductsReward/' + id,
                autoLoad: true, append: false, take: 24,
                scrub(response) {
                    response.data.results = Product.map(response.data.results);
                } });
        }
        $ctrl.products = new AutoQuery({
            url: 'QueryProducts.json',
            orderBy: '-CreatedOn',
            autoLoad: true,
            append: false,
            take: 24,
            criteria: {
                status: 'Active',
                context: 'shop'
            },
            sortOptions: {
                'Id': 'Id: Low to High',
                '-Id': 'Id: High to Low',
                'ShortDescription,Id': 'Description: A to Z',
                '-ShortDescription,Id': 'Description: Z to A',
                'Cost,Id': 'Cost: Low to High',
                '-Cost,Id': 'Cost: High to Low',
                'RetailPrice,Id': 'Price: Low to High',
                '-RetailPrice,Id': 'Price: High to Low',
                'CreatedOn,Id': 'Created: Newest',
                '-CreatedOn,Id': 'Created: Oldest',
                'Status,Id': 'Status: A to Z',
                '-Status,Id': 'Status: Z to A',
            },
            scrub(response) {
                response.data.results = Product.map(response.data.results);
            }
        });
        let bus = $ctrl.bus = $ctrl.products.bus;
    }

    updateOffer() {
        const $ctrl = this;
        let action = "UpdateOffer";
        if ($ctrl.offer.id == 'create') {
            action = "CreateOffer";
        }
        return $ctrl.bus.send(action, $ctrl.offer)
        .then((response) => {
            if (action == "UpdateOffer") {
                $ctrl.$state.go('offers');
            } else {
                let id = response.data.id;
                let options = {
                    url: 'QueryOffers.json?Id=' + id,
                    autoLoad: true,
                    onLoaded: args => {
                        $ctrl.offer = args.first
                        $ctrl.offer.startOn = moment($ctrl.offer.startOn);
                        $ctrl.offer.endOn = moment($ctrl.offer.endOn);
                    }
                };
                $ctrl.query = new AutoQuery(options);
                $ctrl.qualifyProducts = new AutoQuery({ url: 'QueryOfferProductsQualify/' + id, autoLoad: true });
                $ctrl.products = new AutoQuery({ url: 'QueryProducts.json', autoLoad: true });
                $ctrl.rewardProducts = new AutoQuery({ url: 'QueryOfferProductsReward/' + id, autoLoad: true });
            }
        });
    }

    checkProductQualify(id) {
        const $ctrl = this;
        return $ctrl.qualifyProducts.results.map(function (e) { return e.id; }).indexOf(id);
    };

    checkProductReward(id) {
        const $ctrl = this;
        return $ctrl.rewardProducts.results.map(function (e) { return e.id; }).indexOf(id);
    };

    setSelectAll() {
        const $ctrl = this;
        if ($ctrl.selectAll) {
            $ctrl.selectAll = false;
        } else {
            $ctrl.selectAll = true;
        }
        $ctrl.products.results.forEach(function (p, index) {
            $ctrl.products.results[index].isSelected = $ctrl.selectAll;
        });
    }

    addProduct(id, type) {
        let $ctrl = this;
        let productIds = [];
        productIds.push(id);
        if ($ctrl.offer.id == 'create') {
            $ctrl.updateOffer().then(function () {
                return $ctrl.bus.send('AddOfferProducts', { id: $ctrl.offer.id, type: type, productIds: productIds })
                .then(function (response) {
                    $ctrl.qualifyProducts.load(true).then(function (response) {
                        $ctrl.products.load(true);
                    });
                    $ctrl.rewardProducts.load(true).then(function (response) {
                        $ctrl.products.load(true);
                    });
                });
            });
        } else {
            return $ctrl.bus.send('AddOfferProducts', { id: $ctrl.offer.id, type: type, productIds: productIds })
            .then(function (response) {
                $ctrl.qualifyProducts.load(true).then(function (response) {
                    $ctrl.products.load(true);
                });
                $ctrl.rewardProducts.load(true).then(function (response) {
                    $ctrl.products.load(true);
                });
            });
        }
    }

    addAllProducts(type) {
        let $ctrl = this;
        if ($ctrl.offer.id == 'create') {
            $ctrl.updateOffer().then(function () {
                return $ctrl.bus.send('AddOfferProducts', { id: $ctrl.offer.id, type: type, search: $ctrl.products.criteria.search })
                .then(function (response) {
                    $ctrl.qualifyProducts.load(true).then(function (response) {
                        $ctrl.products.load(true);
                    });
                    $ctrl.rewardProducts.load(true).then(function (response) {
                        $ctrl.products.load(true);
                    });
                });
            });
        } else {
            return $ctrl.bus.send('AddOfferProducts', { id: $ctrl.offer.id, type: type, search: $ctrl.products.criteria.search })
            .then(function (response) {
                $ctrl.qualifyProducts.load(true).then(function (response) {
                    $ctrl.products.load(true);
                });
                $ctrl.rewardProducts.load(true).then(function (response) {
                    $ctrl.products.load(true);
                });
            });
        }
    }

    removeAllProducts(type) {
        let $ctrl = this;
        return $ctrl.bus.send('RemoveOfferProducts', { id: $ctrl.offer.id, type: type, search: $ctrl.products.criteria.search })
        .then(function (response) {
            $ctrl.qualifyProducts.load(true).then(function (response) {
                $ctrl.products.load(true);
            });
            $ctrl.rewardProducts.load(true).then(function (response) {
                $ctrl.products.load(true);
            });
        });
    }

    removeProduct(id, type) {
        let $ctrl = this;
        let productIds = [];
        productIds.push(id);
        return $ctrl.bus.send('RemoveOfferProducts', { id: $ctrl.offer.id, type: type, productIds: productIds })
        .then(function (response) {
            $ctrl.qualifyProducts.load(true).then(function (response) {
                $ctrl.products.load(true);
            });
            $ctrl.rewardProducts.load(true).then(function (response) {
                $ctrl.products.load(true);
            });
        });
    }
}

let OfferEdit = {
    controller: OfferEditController,
    bindings: {
        offerId:'@'
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default OfferEdit;